import React from 'react'
import { useViewport } from '../../utils';
import recharts from './recharts';
const {
  PieChart: PieRechart,
  Pie,
  Cell
} = recharts

const PieChart = ({data, total, colors}) => {
  const { isMobile } = useViewport()
  const size = isMobile ? 60 : 60

  return (
    <div>
      <PieRechart width={size} height={size}>
        <Pie
          data={data}
          cx={size/2.2}
          cy={size/2.2}
          // innerRadius={size/2.6}
          outerRadius={size/2.1}
          fill="#8884d8"
          paddingAngle={2}
          dataKey="value"
        >
          {
            data.map((entry, index) => <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />)
          }
        </Pie>
      </PieRechart>
      </div>
  )
}

export { PieChart }
